import { defineMessages } from 'react-intl-next';

export const messages: {
	authorizationFail: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	authorizationSuccess: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	authorizationFail: {
		id: 'dynamic-cards-search-page.oauth-banner.authorization-fail',
		defaultMessage: 'Authorization for {product} failed.',
		description: 'Message displayed when authorization fails.',
	},
	authorizationSuccess: {
		id: 'dynamic-cards-search-page.oauth-banner.authorization-success',
		defaultMessage: 'Authorization for {product} successful.',
		description: 'Message displayed when authorization is successful.',
	},
});
